module.exports = __webpack_public_path__ + "static/media/food_selection.2d87d645.svg";